module.exports = __webpack_public_path__ + "static/media/68 - Michael Jackson - Stranger in Moscow.5cc2037d.mp3";